/**
 * Salon Desk — simplified report period presets (non-technical users).
 */
export const SALON_REPORT_PERIOD_PRESETS = [
  { id: 'today', label: 'Today' },
  { id: 'week', label: 'This week' },
  { id: 'month', label: 'This month' },
  { id: 'custom', label: 'Pick dates' },
]

/**
 * @param {string} period
 * @param {{ from?: string, to?: string }} [bounds]
 */
export function salonReportPeriodLabel(period, bounds = {}) {
  if (period === 'today') return 'Today'
  if (period === 'week') return 'This week'
  if (period === 'month') return 'This month'
  if (period === 'custom' && bounds.from && bounds.to) {
    return `${bounds.from} to ${bounds.to}`
  }
  return 'Selected period'
}
